<modal
  #modal
  id="incident-modal"
  (onClose)="onCloseModal()"
  [closeButtonText]="(formStatus === 0) ? appService.CoreCommonLiterals.ButtonClose : null"
  [submitButtonText]="(formStatus === 0) ? appService.CoreCommonLiterals.ButtonSave : null"
  [submitButtonDisabled]="disabledForm"
  [submitOnEnterKey]="true"
  [errorMessage]="errorMessage"
  [modalClass]="parameters?.IncidentElementTypeID === incidentElementTypes.InvolvedVehicles ? 'modal-xl' : 'modal-lg'"
  (onSubmit)="save()"
>
  <modal-header>
    {{((parameters?.Editing) ? appService.CoreCommonLiterals.Edit : appService.CoreCommonLiterals.Add)}}
    -
    <span *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.Dispatches">Asistencia</span> 
    <span *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.Lanes">Pista</span>
    <span *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.InvolvedVehicles">Vehículo</span>
    <span *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.InvolvedPeople">Persona</span>
    <span *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.DamageRegister">Daño preliminar</span>
  </modal-header>
  <modal-content>
    <form novalidate *ngIf="formStatus === 0" #formElement="ngForm">
      <app-incident-assistances
      *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.Dispatches"
      [(ngModel)]="parameters.JsonData" 
      name="jsonData"
      (click)="errorMessage = ''"
      (disableForm)="onDisabledForm($event);"
      [editing]="parameters.Editing"
      [incidentID]="parameters.IncidentID"
      ></app-incident-assistances>

      <app-incident-lanes
      *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.Lanes"
      [(ngModel)]="parameters.JsonData" 
      name="jsonData"
      (click)="errorMessage = ''"
      (disableForm)="onDisabledForm($event);"
      [editing]="parameters.Editing"
      ></app-incident-lanes>
      
      <app-incident-vehicles-involved
      *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.InvolvedVehicles"
      [(ngModel)]="parameters.JsonData" 
      name="jsonData"
      (click)="errorMessage = ''"
      (disableForm)="onDisabledForm($event);"
      [editing]="parameters.Editing"
      #vehicleElement>
      </app-incident-vehicles-involved>

      <app-incident-persons
      *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.InvolvedPeople"
      [(ngModel)]="parameters.JsonData" 
      (click)="errorMessage = ''"
      name="jsonData"
      (disableForm)="onDisabledForm($event);"
      [editing]="parameters.Editing">
      </app-incident-persons>

      <app-incident-damage-register 
      *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.DamageRegister"
      name="jsonData"
      (click)="errorMessage = ''"
      [(ngModel)]="parameters.JsonData"
      [materialAssetsFullList]="materialAssetsFullList"
      (disableForm)="onDisabledForm($event);"
      ></app-incident-damage-register>

      <app-incident-attachments
      *ngIf="parameters?.IncidentElementTypeID === incidentElementTypes.Files"
      name="jsonData"
      (click)="errorMessage = ''"
      [(ngModel)]="parameters.JsonData"
      (disableForm)="onDisabledForm($event);"
      [editing]="parameters.Editing"
      ></app-incident-attachments>
    </form>
  </modal-content>
</modal>